<template>
  <div class="animated fadeIn">
    <div v-if="loading" class="text-center">
      <b-spinner label="Spinning"></b-spinner>
    </div>

    <b-card-body v-if="!loading" class="m-0 pt-0" id="areaImprimir">
      <div class="text-center"></div>
      <b-row class="border-bottom mb-2">
        <b-col>
          <b-img
            :src="img"
            left
            fluid
            style="max-height: 100px"
            alt="Responsive image"
            class="rounded pb-0"
          ></b-img>
          <h1 class="text-right">
            INFORME DE {{ form.process_type }} #{{ form.number }}
          </h1>
          <p class="text-right">{{ form.date | moment }}</p>
          <a href="#" class="float-right text-black-50" @click="descargarPDF"
            ><i class="fa fa-download"></i
          ></a>
        </b-col>
      </b-row>
      <b-row class="mb-4">
        <b-col>
          <div>
            <strong>{{ company_details.company_name }}</strong>
          </div>
          <div>{{ company_details.company_number }}</div>
          <div>{{ company_details.address1 }}</div>
          <div>{{ company_details.address2 }}</div>
          <div>{{ company_details.contact_phone }}</div>
        </b-col>
      </b-row>
      <h6 class="mb-2 font-weight-bold text-uppercase">Entrada a Proceso:</h6>
      <div class="table-responsive-sm">
        <table class="table  table-sm">
          <thead>
            <tr class="font-weight-bold text-uppercase">
              <th class="text-center">#</th>
              <th>Lote</th>
              <th>Código</th>
              <th>Glosa</th>
              <th>Recipiente</th>
              <th class="text-center">CANTIDAD</th>
              <th class="text-right">KN</th>
              <th class="text-right">%</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(content, index) in form.contents_in">
              <td class="text-center align-middle">{{ index + 1 }}</td>
              <td class="left align-middle">{{ content.lot__number }}</td>
              <td class="left">{{ content.product__code }}</td>
              <td class="left">{{ content.product__name }}</td>
              <td class="left">{{ content.container__name }}</td>
              <td class="text-center">{{ content.quantity }}</td>
              <td class="text-right">
                {{ content.net_kilograms | num_format }}
              </td>
              <td class="text-right">
                {{
                  (
                    (content.net_kilograms /
                      arrayFieldSum(form.contents_in, "net_kilograms")) *
                    100
                  ).toFixed(2)
                }}
                %
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr class="font-weight-bold">
              <td />
              <td />
              <td />
              <td />
              <td />
              <td class="text-center">
                {{ parseInt(arrayFieldSum(form.contents_in, "quantity")) }}
              </td>
              <td class="text-right">
                {{ arrayFieldSum(form.contents_in, "net_kilograms") }}
              </td>
              <td class="text-right"></td>
            </tr>
          </tfoot>
        </table>
      </div>

      <h6 class="mb-2 font-weight-bold text-uppercase">Salida de Proceso:</h6>
      <div class="table-responsive-sm">
        <table class="table  table-sm">
          <thead>
            <tr class="font-weight-bold text-uppercase">
              <th class="text-center">#</th>
              <th>Lote</th>
              <th>Código</th>
              <th>Glosa</th>
              <th>Recipiente</th>
              <th v-if="form.process_type === 'ENMALLADO'">Formato</th>
              <th class="text-center">CANTIDAD</th>
              <th class="text-right">KN</th>
              <th class="text-right">%</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(content, index) in form.contents_out">
              <td class="text-center align-middle">{{ index + 1 }}</td>
              <td class="left align-middle">{{ content.lot__number }}</td>
              <td class="left">{{ content.product__code }}</td>
              <td class="left">{{ content.product__name }}</td>
              <td class="left">{{ content.container__name }}</td>
              <td v-if="form.process_type === 'ENMALLADO'">
                {{
                  sellingFormat(
                    content.units_per_container,
                    content.kg_per_unit
                  )
                }}
              </td>
              <td class="text-center">{{ content.quantity }}</td>
              <td class="text-right">
                {{ content.net_kilograms | num_format }}
              </td>
              <td class="text-right">
                {{
                  (
                    (content.net_kilograms /
                      arrayFieldSum(form.contents_out, "net_kilograms")) *
                    100
                  ).toFixed(2)
                }}
                %
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr class="font-weight-bold">
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <th v-if="form.process_type === 'ENMALLADO'"></th>
              <td class="text-center">
                {{ parseInt(arrayFieldSum(form.contents_out, "quantity")) }}
              </td>
              <td class="text-right">
                {{ arrayFieldSum(form.contents_out, "net_kilograms") }}
              </td>
              <td class="text-right"></td>
            </tr>
          </tfoot>
        </table>
      </div>
      <div>
        <p>Documento(s): {{ form.documents }}</p>
        <p>Nota(s):</p>
      </div>
      <hr />
      <p class="small text-center"></p>
    </b-card-body>
  </div>
</template>

<script>
import html2pdf from "html2pdf.js";
import moment from "moment";
import numeral from "numeral";
import { mapState } from "vuex";
import _ from "lodash";

export default {
  name: "ProcessReport",
  props: {
    process: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      img: "",
      client: null,
      loading: false
    };
  },
  filters: {
    moment: function(date) {
      return moment(date).format("DD-MM-YYYY");
    },
    num_format(value) {
      value = parseFloat(value);
      return numeral(value).format("0,0.00");
    }
  },
  computed: {
    ...mapState("bagnoProcessModule", ["form"]),
    ...mapState({ company_details: state => state.user.DETAILS })
  },
  created() {
    this.img = localStorage.getItem("img");
    this.client = this.$store.getters.user.ID_CLIENTE;
    this.getProcess(this.process);
  },
  destroyed() {
    this.$store.dispatch("bagnoProcessModule/cleanProcess");
  },
  methods: {
    sellingFormat(units, kg) {
      return units !== 0 ? units + "Un x " + kg + "Kg" : "";
    },
    arrayFieldSum(array, field) {
      return array
        .reduce((acc, item) => acc + parseFloat(item[field]), 0)
        .toFixed(2);
    },
    async getProcess(evt) {
      const thisV = this;
      let url = "";
      thisV.loading = true;
      url = `bagno/process/${evt}/process_report/`;
      try {
        const response = await thisV.$axios({
          method: "GET",
          url: url
        });
        thisV.$store.commit("bagnoProcessModule/updateProcess", response.data);
        thisV.$toast.success(`Proceso #${evt} cargado con éxito`, "");
        thisV.loading = false;
      } catch (error) {
        console.log(error);
        thisV.$toast.error("Problemas al cargar proceso", "");
        thisV.loading = false;
      }
    },
    printDiv() {
      const prtHtml = document.getElementById("areaImprimir").innerHTML;
      let stylesHtml = "";
      for (const node of [
        ...document.querySelectorAll('link[rel="stylesheet"], style')
      ]) {
        stylesHtml += node.outerHTML;
      }
      const WinPrint = window.open(
        "",
        "",
        "left=0,top=5,width=1280,height=2900,toolbar=0,scrollbars=0,status=0"
      );
      WinPrint.document.write(`<!DOCTYPE html>
          <html>
            <head>
              ${stylesHtml}
            </head>
            <body>
              ${prtHtml}
            </body>
          </html>`);

      WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
      WinPrint.close();
    },
    descargarPDF() {
      const element = document.getElementById("areaImprimir").innerHTML;
      const opt = {
        margin: 0.25,
        image: { type: "jpeg", quality: 0.5 },
        filename: "Informe Proceso #213.pdf",
        // html2canvas: { dpi: 192, letterRendering: true },
        jsPDF: { unit: "in", format: "letter", orientation: "landscape" }
      };
      html2pdf(element, opt);
    }
  }
};
</script>

<style scoped>
.table-sm th,
.table-sm td {
  padding: 0.15rem;
}
</style>
